'use strict';

var TrendChartDataProviderService = function TrendChartDataProviderService(dataRetrieverService) {
  function getData(screen, mode, type) {
    return dataRetrieverService.getDataRetriever(screen, mode).localSortApplied().retrieveComponentData(type);
  }
  function getFilters(screen, mode) {
    return dataRetrieverService.getDataRetriever(screen, mode).brushFilters();
  }
  return {
    getData: getData,
    getFilters: getFilters
  };
};
TrendChartDataProviderService.$inject = ['DataRetrieverService'];
module.exports = TrendChartDataProviderService;